import {
  LOGIN_STATUS_START,
  UserContextLoginStatus,
} from "store/types/user-context.types";
import { User } from "model/user.model";
import { UserConfiguration } from "model/user-configuration.model";

export interface UserContextType {
  user: User;
  practice: string;
  accessToken: string;
  ehealthKeyStorePasswordKey: string;
  stsToken: string;
  loginStatus: UserContextLoginStatus;
  loginError: string;
  licenseUrl: string;
  tenantOptions: [];
  useEAttest: boolean;
}

export class UserContext implements UserContextType {
  user: User;
  practice: string;
  accessToken: string;
  ehealthKeyStorePasswordKey: string;
  stsToken: string;
  loginStatus: UserContextLoginStatus;
  loginError: string;
  licenseUrl: string;
  tenantOptions: [];
  useEAttest: boolean;
  userConfiguration: UserConfiguration;

  constructor(data?: UserContextType) {
    this.user = new User();
    this.practice = "";
    this.accessToken = "";
    this.ehealthKeyStorePasswordKey = "";
    this.stsToken = "";
    this.loginStatus = LOGIN_STATUS_START;
    this.loginError = "";
    this.licenseUrl = "";
    this.tenantOptions = [];
    this.useEAttest = false;
    this.userConfiguration = new UserConfiguration("", false, false);
    data && Object.assign(this, data);
    data && data.user && Object.assign(this.user, new User(data.user));
  }
}
